"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["message", "theme", "className", "testId"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  theme: {},
  message: 'No data to show'
};

/**
 * Provides a component to display a message when there is no data to show.
 */
var EmptyResult = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(EmptyResult, _React$Component);
  function EmptyResult() {
    (0, _classCallCheck2["default"])(this, EmptyResult);
    return _callSuper(this, EmptyResult, arguments);
  }
  (0, _createClass2["default"])(EmptyResult, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        message = _this$props.message,
        theme = _this$props.theme,
        className = _this$props.className,
        testId = _this$props.testId,
        other = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, other, {
        className: (0, _classnames["default"])(theme.emptyResult, className /* user specified classNames */),
        "data-test-id": testId,
        "data-anypoint-component": EmptyResult.displayName
      }), /*#__PURE__*/_react["default"].createElement("span", {
        "data-test-id": testId && "".concat(testId, "-image"),
        className: theme.image
      }), /*#__PURE__*/_react["default"].createElement("span", {
        "data-test-id": testId && "".concat(testId, "-message"),
        className: theme.message
      }, message));
    }
  }]);
  return EmptyResult;
}(_react["default"].Component);
(0, _defineProperty2["default"])(EmptyResult, "defaultProps", defaultProps);
(0, _defineProperty2["default"])(EmptyResult, "displayName", 'EmptyResult');
//# sourceMappingURL=EmptyResult.js.map